// extracted by mini-css-extract-plugin
module.exports = {"modal":"DeleteButton_modal__3Kseu","buttonWrapper":"DeleteButton_buttonWrapper__3WEWw","buttonReset":"DeleteButton_buttonReset__2khmj","button":"DeleteButton_button__3lahr"};